import script from "./AvatarPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./AvatarPreview.vue?vue&type=script&setup=true&lang=js"

import "./AvatarPreview.vue?vue&type=style&index=0&id=761502d8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-761502d8"]])

export default __exports__